"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FaceFemale = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M11.5,3 C15.5609173,3 18.8680175,6.22747441 18.9961464,10.2572689 L19,17 L16.400091,17.0003901 C15.4896644,18.781016 13.6371867,20 11.5,20 C9.36287562,20 7.51044361,18.781087 6.59998863,17.0005458 L4,17 L4,10.5 C4,6.35786438 7.35786438,3 11.5,3 Z M10.5366767,8.48701217 C9.8789608,9.63594048 8.57746798,10.7655932 6.99996017,10.9679685 L6.99996017,14.5 C6.99996017,16.9852814 9.01471863,19 11.5,19 C13.9142733,19 15.8897508,17.1081349 16.0003638,14.7212071 L16.0003638,10.9862129 C13.6188441,10.8549413 11.493596,9.8016197 10.5366767,8.48701217 Z M18,11 L17,11 L17,14.5 C17,15.0200759 16.9278151,15.5232921 16.7929177,16.0001762 L18,16 L18,11 Z M6,11 L5,11 L5,16 L6.20720779,16.0006197 C6.09145193,15.5915359 6.02184504,15.1630717 6.0043672,14.7212071 L6,11 Z M11.5,4 C8.07815715,4 5.27388358,6.64412846 5.01889382,10.0006709 L6.5,10 C7.59663394,10 8.48829167,9.49299854 9.17520644,8.62681816 C9.61749185,8.06910859 9.94603303,7.34820074 9.99396075,7.06211623 L10.0080557,6.91012437 C10.0503916,6.67687516 10.2545401,6.5 10.5,6.5 C10.7761424,6.5 11,6.72385763 11,7 C11,8.31910641 13.3948406,9.90639792 16.2471846,9.99602347 L17.9811062,10.0006709 C17.7261164,6.64412846 14.9218429,4 11.5,4 Z" })));
};
FaceFemale.displayName = 'FaceFemale';
exports.default = FaceFemale;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FaceFemale.js.map